import { render, staticRenderFns } from "./DonutChart43.vue?vue&type=template&id=4b54c6f5&scoped=true"
import script from "./DonutChart43.vue?vue&type=script&lang=js"
export * from "./DonutChart43.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b54c6f5",
  null
  
)

export default component.exports